// Statics.
import './scripts/StylesImports';
import './scripts/ImagesImports';

// Application Scripts.
import { toiConfig } from '../Settings/global.json';
//import * as Login from './scripts/common/login';
import * as app from './scripts/Core/App';
import * as ToiProviderBuilder from './scripts/Core/Toi/ToiProvider';
import LNComscore from './scripts/Modules/LNComscore';
//import * as Header from './scripts/Header';
import * as EplanningConfigProvider from './scripts/Modules/Eplanning/EplanningConfigProvider';
import * as DFPConfigProvider from './scripts/Modules/DFP/DFPConfigProvider';
import DFP from './scripts/Modules/DFP/DFP';
import Eplanning from './scripts/Modules/Eplanning/Eplanning';
//import TePuedeInteresar from './scripts/Modules/TePuedeInteresar';
import ShareSocial from './scripts/Modules/Sharing';
import Leaflet from './scripts/Modules/Leaflet';
import MobileVersion from './scripts/Modules/MobileVersion';
import Hotjar from './scripts/Modules/Hotjar';
import Analytics from './scripts/Modules/Analytics';


const routesUrls = [
    { "sectionHeader": ["Header/Header"], "cargado": false },
    { "sectionSubHeader": ["Header/Parciales/SubHeader"], "cargado": false },
    { "sectionFooter": ["_Footer"], "cargado": false }
];
// Application Start.
app.start().then(() => {
    const providerFactory = ToiProviderBuilder.Initialize(toiConfig);


    // Si es App
    const estoyEnApp = _verificarEstoyEnApp();
    if (typeof estoyEnApp === "undefined" || estoyEnApp === null || estoyEnApp === false) {
        routesUrls.forEach(r => {
            _loadSections(r).then(function (resp) {
                if (typeof r["sectionHeader"] !== "undefined" && r["sectionHeader"] !== null && resp === true) {
                    //Carga de funcionalidades
                    _initializeLogin();
                    _initializeHeader();

                }

                console.log(resp)
            }).catch(function (err) {
                // Run this when promise was rejected via reject()
                console.log(err)
            })
        });

    }


    // Comscore.
    _initializeComscore();

    // Header.
    //_initializeHeader();

    // Te Puede Interesar.
    //_initializeTePuedeInteresar(providerFactory);

    // Sharing social
    _initializeSharing();

    // Mobile Version
    _initializeMobileVersion();

    // Analytics
    _initializeAnalytics();

    $(document).ready(function () {
        //_initializeLogin();

        // Hotjar.
        _initializeHotjar();
    });
});

// Private.

function _initializeComscore() {
    LNComscore.TriggerPageView();
}

//function _initializeHeader() {
//    Header.Initialize();
//}

function _initializeHeader() {
    var Header = require('./scripts/Header');
    Header.Initialize();
}

function _initializeHotjar() {
    const $module = new Hotjar();

    $module.Load();
    $module.triggerRecording();
    $module.startPoll();
}

function _verificarEstoyEnApp() {
     const $module = new MobileVersion();
    return $module.isMobile();
}

function _initializeMobileVersion() {
    const $module = new MobileVersion();
    $module.Load();
}

//function _initializeTePuedeInteresar(providerFactory) {
//    const provider = providerFactory.getToiProvider('liftigniter');
//    const $module = new TePuedeInteresar(provider, {
//        max: 6
//    });

//    $module.Load();
//}

function _initializeSharing() {
    ShareSocial.Initialize();
}

function _initializeAnalytics() {
    Analytics.listenTrackLinks();
}

//function _initializeLogin() {
//    Login.Initialize();
//}

function _initializeLogin() {
    var Login = require('./scripts/common/login.js');
    Login.Initialize();
}

function _loadSections(obj) {
    let results = [];
    return new Promise(function (resolve, reject) {

        var hostUrl = location.protocol.concat("//").concat(window.location.host).concat('/cartelera-de-cine/Element');
        //if (typeof window.config.Statics.DominioPrincipal !== "undefined" && window.config.Statics.DominioPrincipal !== null && typeof window.config.Statics.DominioPrincipal !== "object") {
        //    hostUrl = window.config.Statics.DominioPrincipal.concat('cartelera-de-cine/Element');
        //}
        Object.entries(obj).forEach(([key, value]) => {
            if (key !== 'cargado') {
                if (Array.isArray(value)) {
                    value.forEach((c, i, r) => {
                        $.ajax({
                            url: hostUrl,
                            data: { "url": c },
                            dataType: "html",
                            type: "GET",
                            contentType: "application/json",
                            success: function (response) {
                                $('#' + key).before(response);
                                results.push(true);
                                if (i === (value.length - 1)) {
                                    resolve(results.filter(x => x === false).length === 0);
                                }
                            },
                            error: function (err) {
                                results.push(false);
                                reject(false);

                            }
                        });
                    })

                }
            }


        })
    });

}




// WEBPACK FOOTER //
// ./Statics/site.js